import { render, staticRenderFns } from "./ScrollableContainer.vue?vue&type=template&id=54b8a4a1"
import script from "./ScrollableContainer.vue?vue&type=script&lang=js"
export * from "./ScrollableContainer.vue?vue&type=script&lang=js"
import style0 from "./ScrollableContainer.vue?vue&type=style&index=0&id=54b8a4a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports